<template>
  <article :post="post">
    <div class="container p-4">
      <div class="page-main">
        <div class="page-title">
          <h1 v-html="post[0].title.rendered"></h1>
        </div>
        <div class="row p-0">
          <div class="col-md-12">
            <div class="page">
              <div class="page-content" id="page-content">
                <div id="contentRendered" v-html="post[0].content.rendered"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
  import axios from "axios";

  export default {
    name: 'Page',
    data () {
      return {
        queryOptions: {
          _embed: true,
        },
        post: [],
      }
    },
    created () {
      this.getPost()
    },
    methods: {
      getPost () {
        var path = this.$route.path.split('/')
        axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/pages/?slug=' + path[path.length - 1], {params: this.queryOptions})
        .then(response => {
          this.post = response.data

          if (this.post === undefined) {
            this.$router.push({name: 'NotFound'})
          }
          document.title = this.post[0].title.rendered
        })
        .catch(e => {
          console.log(e)
        })
      },
    },
    /*computed: {
      strippedContent() {
        let regex = /(width=")\d+("\W+height=")\d+/;
        return this.post[0].content.rendered.replace(regex, "");
      }
    }*/
}
</script>
<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}
#page-content >>> a,
#page-content >>> a:hover,
#page-content >>> a:active,
#page-content >>> a:visited {
  opacity: 1.0;
}
#page-content >>> img:hover {
  pointer-events: none;
}
.page-main {
  margin-top: 50px;
}
.page-main {
  padding: 5px 0;
  margin: 50px 0;
  font-family: 'Raleway', sans-serif;
}
.page-title h1 {
  font-family: 'Raleway', sans-serif;
  font-size: 24px;
  font-size: 400;
  text-transform: uppercase;
  letter-spacing: 2.4px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-content {
  max-width: 1280px;
}
#contentRendered {
  margin-top: 20px;
}
#contentRendered >>> img {
  width: 80%;
  height: auto;
}
#contentRendered >>> h4 {
  font-family: 'Raleway', sans-serif;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
#contentRendered >>> a {
  text-decoration: none;
  color: #000;
  font-weight: 600;
}
#contentRendered >>> a,
#contentRendered >>> p,
#contentRendered >>> span,
#contentRendered >>> h4,
#contentRendered >>> h3 {
  word-break: break-word;
}
.page-info {
  margin: 0 40px;
}
.page-info h2 {
  font-family: 'Raleway', sans-serif;
  font-size: 42px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #000000;
}
.page-info p {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 700;
}
.page-content p {
  font-size: 16px;
}
article {
  min-height: 80vh;
}
</style>
